import { useContext, Fragment } from 'react';
import { GlobalContext } from '../context/GlobalState';
import { closeOverlay, setDeliveryOptionButtonSelected, updateDeliveryIsSelected, validateCheckout } from '../functions';

const Select = props => {
	const [ state, dispatch, notify ] = useContext( GlobalContext );
	const { shipment } = state;

	return (
		<div className="digital-code-select">
			<div className="select-header">
				<h1>Välj leveranssätt för registreringskoder</h1>
				<p>För att få åtkomst till den digitala produkten behöver du ha en registreringskod.</p>
			</div>

			{ 'Email' === props.distributionMethod
				? <Fragment>
					<input className="faux-radio-checkbox faux-checkbox" id="self" name="shipment" value="pdf" type="radio" checked={ 'pdf' === shipment } onChange={ () => {
						dispatch( { type: 'SET_SHIPMENT', payload: 'pdf' } );
					} } />
					<label htmlFor="self" className="faux-radio-checkbox-label">
						<div>
							<h2>Till en e-postadress</h2>
							<span>Skickas som pdf-fil till din e-postadress.</span>
						</div>
					</label>
				</Fragment>
				: null
			}

			{ 'Email' === props.distributionMethod
				? <Fragment>
					<input className="faux-radio-checkbox faux-checkbox" id="list" name="shipment" value="emails" type="radio" checked={ 'emails' === shipment } onChange={ () => {
						dispatch( { type: 'SET_SHIPMENT', payload: 'emails' } );
					} } />
					<label htmlFor="list" className="faux-radio-checkbox-label">
						<div>
							<h2>Till deltagarnas e-postadresser</h2>
							<span>Registreringskoder skickas till angivna deltagare och en bekräftelse skickas också till din e-postadress.</span>
						</div>
					</label>
				</Fragment>
				: null }

			{ 'Folder' === props.distributionMethod
				? <Fragment>
					<input className="faux-radio-checkbox faux-checkbox" id="post" name="shipment" value="post" type="radio" checked={ 'post' === shipment } onChange={ () => {
						dispatch( { type: 'SET_SHIPMENT', payload: 'post' } );
					} } />
					<label htmlFor="post" className="faux-radio-checkbox-label">
						<div>
							<h2>Till din leveransadress</h2>
							<span>Din registreringskod levereras i tryckt format och levereras med post.</span>
						</div>
					</label>
				</Fragment>
				: null }

			<nav className="group-right">
				<a className="button btn-fifthary close-digital-box" onClick={ () => { // eslint-disable-line jsx-a11y/anchor-is-valid, jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
					closeOverlay( dispatch, state );
				} }>Avbryt</a>

				{ 'pdf' === shipment
					? <a className="button btn-secondary" onClick={ () => { // eslint-disable-line jsx-a11y/anchor-is-valid, jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
						dispatch( {
							type: 'SET_IS_LOADING',
							payload: true,
						} );
						// eslint-disable-next-line no-undef
						fetch( sisuReact.admin_ajax, {
							method: 'POST',
							headers: {
								'Content-Type': 'application/x-www-form-urlencoded',
								'Access-Control-Allow-Origin': '*',
							},
							credentials: 'same-origin',
							body: new URLSearchParams( {
								action: 'digital_code_save_line_meta',
								// eslint-disable-next-line no-undef
								nonce: sisuReact.nonce,
								cartItemKey: props.cartItemKey,
								distributionMethod: 'ORDERMOTTAGARE',
							} ),
						} ).then( function( response ) {
							return response.json();
						} ).then( function( data ) {
							dispatch( {
								type: 'SET_IS_LOADING',
								payload: false,
							} );
							if ( 'false' === data ) {
								notify( 'Något gick fel. Försök igen.' );
							} else {
								notify( 'Ändring sparad.', 'success' );
								updateDeliveryIsSelected( props.cartItemKey, 'true' );
								validateCheckout();
								dispatch( {
									type: 'SET_IS_SAVED',
									payload: true,
								} );
								dispatch( {
									type: 'SET_EMAILS',
									payload: [],
								} );

								dispatch( {
									type: 'SET_SAVED_DISTRIBUTION_METHOD',
									payload: 'ORDERMOTTAGARE',
								} );

								setDeliveryOptionButtonSelected( props.cartItemKey );
								setTimeout( () => {
									dispatch( {
										type: 'SET_OVERLAY_VISIBILITY',
										payload: false,
									} );
									notify( null );
									dispatch( {
										type: 'SET_STEP',
										payload: 'savedData',
									} );
								}, 1000 );
							}
						} );
					} }>Spara</a>
					:					<a className={ ! shipment ? 'button btn-secondary disabled' : 'button btn-secondary' } onClick={ () => { // eslint-disable-line jsx-a11y/anchor-is-valid, jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
						if ( ! shipment ) {
							return;
						}

						dispatch( {
							type: 'SET_STEP',
							payload: shipment,
						} );
					} }>Fortsätt</a>
				}
			</nav>
		</div>
	);
};

export default Select;
